import { currentYear } from 'shared/datetime'

export const Footer = () => (
  <div className='sticky left-0 shrink-0 border-t border-t-gray-200 bg-white px-12 py-4'>
    <span>© JetRuby 2018-{currentYear}</span>
  </div>
)
